function cov_13w6f61q06() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChatVersionTwoFilled.tsx";
  var hash = "00c1338a4d9a13ace9ea2ee702fd68bdf0aab413";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChatVersionTwoFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "00c1338a4d9a13ace9ea2ee702fd68bdf0aab413"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_13w6f61q06 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_13w6f61q06();
var Icon = (cov_13w6f61q06().s[0]++, {
  name: 'chat-2-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 5C2 3.34315 3.34315 2 5 2H22V15C22 16.6569 20.6569 18 19 18H16L11.75 22L8 18H2V5ZM7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12ZM8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9H16C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7H8Z\" fill=\"currentColor\"/>"
});
export default Icon;